
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { BorrowerVerificationUserEnrollmentRequest, BorrowerVerificationUserEnrollmentResponse } from '../models/borrower-verification-user-enrollment.model';

const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'auth-req': 'true', 'X-Requested-With': 'XMLHttpRequest' });

@Injectable()
export class AssetService {

  constructor(private readonly _dataService: DataService) {
  }

  public markFormFreeForBorrowerComplete = (borrowerId: number, applicationId: number): Observable<any> => {
    const url = `api/online-app/MarkFormFreeForBorrowerComplete/${applicationId}/${borrowerId}`;
    return this._dataService.post(url, {});
  }

  public initializeBorrowerAssetVerification = (borrowerId: number, applicationId: number, integrationProvider): Observable<BorrowerVerificationUserEnrollmentResponse> => {
    const request: BorrowerVerificationUserEnrollmentRequest = {
      applicationId: applicationId,
      borrowerId: borrowerId,
      maxHeightInPixels: 600,
      maxWidthInPixels: 800,
      integrationProvider: integrationProvider,
      allowedProducts: ['Assets'],
      inviteAllApplicationBorrowers: false
    };
    const url = `api/online-app/borrower-verification/invite`;
    return this._dataService.post(url, request);
  }

}
